// The Messages app's conversations. Like the Phone app's people they're made up (the same cast),
// except the first: a thread with Sylvester himself, where a visitor's message opens as an email
// to him. `ago` is minutes since the last message, so the list always reads as recent; `unread`
// shows the blue dot. Each message is from "them" or "me".

export const THREADS = [
  {
    id: "me",
    who: "me",
    unread: true,
    ago: 2,
    messages: [
      { from: "them", text: "Hi, I'm Sylvester 👋" },
      { from: "them", text: "I'm a software engineer. My resume is in Notes, down in the dock." },
      { from: "them", text: "Want to get in touch? Send me a message here and it'll open as an email to me." },
    ],
  },
  {
    id: "recruiter",
    who: "recruiter",
    unread: true,
    ago: 47,
    messages: [
      {
        from: "them",
        text: "Hi Sylvester! I came across your profile and think you'd be a great fit for a role on our team. Are you open to a chat this week?",
      },
    ],
  },
  {
    id: "don",
    who: "don",
    unread: true,
    ago: 95,
    messages: [
      { from: "them", text: "Saw your website." },
      { from: "them", text: "Make it simple, but significant." },
    ],
  },
  {
    id: "mom",
    who: "mom",
    unread: true,
    ago: 185,
    messages: [
      { from: "them", text: "Have you eaten?" },
      { from: "me", text: "Yes mom" },
      { from: "them", text: "Call me when you're free" },
    ],
  },
  {
    id: "thanos",
    who: "thanos",
    ago: 60 * 7,
    messages: [
      { from: "me", text: "Did you get everything on the list?" },
      { from: "them", text: "The hardest choices require the strongest wills." },
      { from: "them", text: "Also we're out of milk." },
    ],
  },
  {
    id: "arthur",
    who: "arthur",
    unread: true,
    ago: 60 * 10,
    messages: [
      { from: "them", text: "Strange contraption, this phone." },
      { from: "them", text: "Meet me at the camp by Horseshoe Overlook. Bring coffee." },
    ],
  },
  {
    id: "rick",
    who: "rick",
    unread: true,
    ago: 60 * 22,
    messages: [{ from: "them", text: "Need you for an adventure. 20 minutes, in and out." }],
  },
  {
    id: "kyle",
    who: "kyle",
    ago: 60 * 30,
    messages: [
      { from: "them", text: "Any news on the season 4 script?" },
      { from: "me", text: "Working on it. Promise it'll answer everything." },
    ],
  },
  {
    id: "darwin",
    who: "darwin",
    ago: 60 * 40,
    messages: [
      { from: "them", text: "Gumball and I are building a website too!!" },
      { from: "them", text: "It's for school. Can you help? 🐟" },
      { from: "me", text: "Of course. Start with the Notes app, it's the best part." },
    ],
  },
  {
    id: "kwame",
    who: "kwame",
    ago: 60 * 52,
    messages: [{ from: "them", text: "Leg day tomorrow. No excuses 💪" }],
  },
  {
    id: "area51",
    who: "area51",
    unread: true,
    ago: 60 * 24 * 3,
    messages: [{ from: "them", text: "Your visitor pass for Site 15 has expired. Please do not attempt to renew it." }],
  },
  {
    id: "tony",
    who: "tony",
    ago: 60 * 24 * 5,
    messages: [
      { from: "them", text: "Saw your Kubernetes setup." },
      { from: "them", text: "Not Stark-level. But not bad." },
    ],
  },
  {
    id: "morty",
    who: "morty",
    ago: 60 * 24 * 8,
    messages: [{ from: "them", text: "Have you seen Rick??" }],
  },
];
